import React from 'react';
import { Box } from '@apia/theme';
import { TResponsiveTableContextProps } from '../../types';
import Filter from './Filter';

const FiltersRender = React.forwardRef(
  (
    {
      className,
      filters,
    }: { className: string; filters: TResponsiveTableContextProps['filters'] },
    ref,
  ) => {
    return (
      <Box ref={ref} className={`filtersRender ${className}`}>
        {filters?.map((filter) => {
          return <Filter key={filter.id} filter={filter} />;
        })}
      </Box>
    );
  },
);

export default React.memo(FiltersRender);
